// useSimilarStyle.js
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getSimilarStyle } from "../services/similarProducts.service"; // ensure correct path
import { useCartWishlist } from "../../../../app/CartWishlistContext";
import { addToWishlist, removeFromWishlist } from "../../../../components/Wishlist/WishlistSlice";

const useSimilarStyle = (categorySlug = "floor-covering") => {
  const dispatch = useDispatch();
  const { getCartWishlistCount } = useCartWishlist();

  const [similarStyle, setSimilarStyle] = useState([]);
  const [loading, setLoading] = useState(true);
  const [animatedWish, setAnimatedWish] = useState(null);

  /** Fetch similar styles */
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const data = await getSimilarStyle(categorySlug);

        const mapped = data.map((item) => ({
          ...item,
          media_list: {
            main: { file: item.media },
            hover: item.product_media?.[1] ? { file: item.product_media[1].file } : null,
          },
          selling_price: item.price,
          is_wishlisted: item.wishlist?.length > 0,
          wishlist: item.wishlist || [],
        }));

        setSimilarStyle(mapped.slice(0, 10));
      } catch (error) {
        console.error("Similar style fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [categorySlug]);

  /** Wishlist toggle */
  const toggleWishlist = async (e, product) => {
    e.stopPropagation();
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Please login to manage wishlist");
      return;
    }

    try {
      if (product.is_wishlisted) {
        const wishlistItem = product.wishlist[0]?.wishlist_id;
        if (wishlistItem) {
          await dispatch(removeFromWishlist(wishlistItem)).unwrap();
          setSimilarStyle((prev) =>
            prev.map((p) => (p.id === product.id ? { ...p, is_wishlisted: false, wishlist: [] } : p))
          );
          getCartWishlistCount();
        }
      } else {
        const addedWishlistItem = await dispatch(addToWishlist({ product_id: product.id })).unwrap();
        const wishlist = Array.isArray(addedWishlistItem)
          ? addedWishlistItem.find((w) => w.product_id === product.id)
          : addedWishlistItem;

        setSimilarStyle((prev) =>
          prev.map((p) =>
            p.id === product.id
              ? { ...p, is_wishlisted: true, wishlist: wishlist ? [{ wishlist_id: wishlist.id }] : [] }
              : p
          )
        );

        setAnimatedWish(product.id);
        setTimeout(() => setAnimatedWish(null), 1500);
        getCartWishlistCount();
      }
    } catch {
      alert("Something went wrong with wishlist");
    }
  };

  return { similarStyle, loading, toggleWishlist, animatedWish };
};

export default useSimilarStyle;